/**
 * API Endpoints Configuration
 * Centralized location for all API endpoints
 */

export const ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    VERIFY: '/auth/verify',
    CHANGE_PASSWORD: '/auth/changePassword',
    CHANGE_PASSWORD_FIRST_TIME: '/auth/changePasswordFirstTime',
    SESSION: '/auth/session',
  },

  // KOT (Kitchen Order Ticket)
  KOT: {
    CREATE: '/api/orders',
    GET_ALL: '/api/orders',
    GET_BY_ID: (id) => `/api/orders/${id}`,
    UPDATE_STATUS: (id) => `/api/orders/${id}/status`,
    CANCEL: (id) => `/api/orders/${id}/cancel`,
    CANCEL_BY_TABLE_SPLIT: (tableId, tableSplit) => `/api/orders/cancel/${tableId}/${tableSplit}`,
    GET_BY_TABLE: (tableId) => `/api/orders/table/${tableId}`,
    GET_ACTIVE_BY_TABLE_SPLIT: (tableId, tableSplit) => `/api/orders/table/${tableId}/${tableSplit}/active`,
  },

  // Bills
  BILLS: {
    CREATE: '/api/bills',
    GET_ALL: '/api/bills/bills',
    GET_BY_ID: (id) => `/api/bills/${id}`,
    GET_ITEMS: (id) => `/api/bills/${id}/items`,
    GET_PAYMENTS: (id) => `/api/bills/${id}/payments`,
    UPDATE_STATUS: (id) => `/api/bills/${id}/status`,
    CANCEL: (id) => `/api/bills/${id}/cancelBill`,
    GET_BY_TABLE: (tableId) => `/api/bills/table/${tableId}`,
    GET_PENDING_BY_TABLE_SPLIT: (tableId, tableSplit) => `/api/bills/table/${tableId}/split/${tableSplit}/pending`,
    GET_BILL_TABLE_SUMMARY: '/api/layout/table/bills-table',
    GET_RECENT: '/api/bills/recent',
    UPDATE_PAYMENT_MODE: (id) => `/api/bills/${id}/payment-mode`,
    GET_ALL_PENDING: (tableId, tableSplit) => `/api/bills/table/${tableId}/split/${tableSplit}/pending-all`,
    GET_AUDIT_LOGS: '/api/bills/audit-logs',
  },
  //importFromMenu
  INVENTORY: {
    IMPORT_FROM_MENU: '/api/inventory/import-from-menu'
  },
  // Menu
  MENU: {
    GET_ALL: '/api/admin/menu',
    GET_BY_ID: (id) => `/api/admin/menu/${id}`,
    CREATE: '/api/admin/menu',
    UPDATE: (id) => `/api/admin/menu/${id}`,
    DELETE: (id) => `/api/admin/menu/${id}`,
    GET_BY_CATEGORY: (categoryId) => `/api/admin/menu?categoryId=${categoryId}`,
    BULK_UPLOAD: '/api/admin/menu/bulk-upload',
    DOWNLOAD_TEMPLATE: '/api/admin/menu/template',
    BULK_PRICE_UPDATE: '/api/admin/menu/bulk-price-update',
  },

  MENU_CATEGORY: {
    GET_ALL: '/api/admin/menu-category',
    GET_BY_ID: (id) => `/api/admin/menu-category/${id}`,
    CREATE: '/api/admin/menu-category',
    UPDATE: (id) => `/api/admin/menu-category/${id}`,
    DELETE: (id) => `/api/admin/menu-category/${id}`,
  },

  // Tables
  //   TABLES: {
  //   GET_ALL: '/admin/tables',
  //   GET_BY_ID: (id) => `/admin/tables/${id}`,
  //   UPDATE: (id) => `/admin/tables/${id}`,
  //   UPDATE_STATUS: (id) => `/admin/tables/${id}/status`,
  //   GET_BY_SECTION: (section) => `/admin/tables/section/${section}`,
  //   MERGE: '/admin/tables/merge',
  //   TRANSFER: '/admin/tables/transfer',
  // },


  // Payments
  PAYMENTS: {
    PROCESS: '/api/payments',
    GET_BY_ORDER: (orderId) => `/api/payments/order/${orderId}`,
    REFUND: (id) => `/api/payments/${id}/refund`,
  },

  PAYMENT_ACCOUNTS: {
    BASE: '/api/admin/payment-accounts',
    GET_ALL: '/api/admin/payment-accounts',
    GET_BY_ID: (id) => `/api/admin/payment-accounts/${id}`,
    CREATE: '/api/admin/payment-accounts',
    UPDATE: (id) => `/api/admin/payment-accounts/${id}`,
    DELETE: (id) => `/api/admin/payment-accounts/${id}`,
  },


  DAY_CLOSE: {
    GET_SUMMARY: '/api/day-close/summary',
    EXECUTE: '/api/day-close/execute',
    REOPEN: '/api/day-close/reopen',
    HISTORY: '/api/day-close/history',
    DOWNLOAD_PDF: '/api/day-close/pdf',
  },

  SHIFTS: {
    ACTIVE: '/api/shifts/active',
    START: '/api/shifts/start',
    END: (id) => `/api/shifts/${id}/end`,
    SUMMARY: (id) => `/api/shifts/${id}/summary`,
    TODAY: '/api/shifts/today',
    CONFIG: '/api/shifts/config',
    FORCE_CLOSE: (id) => `/api/shifts/${id}/force-close`,
  },

  DASHBOARD: {
    GET_SUMMARY: '/api/admin/dashboard/summary',
    GET_TOP_SELLING: '/api/admin/dashboard/top-selling',
    GET_PAYMENT_MODEWISE: '/api/admin/dashboard/payment-collection-mode-wise',
    GET_REVENUE_TREND: '/api/admin/dashboard/revenue-trend',
    GET_RECENT_ORDERS: '/api/admin/dashboard/recent-orders',
    GET_REVENUE_SUMMARY: '/api/admin/dashboard/revenue-summary',
    GET_ORDERS_SUMMARY: '/api/admin/dashboard/orders-summary',
    GET_PAYMENT_SPLIT: '/api/admin/dashboard/payment-split',
    GET_TOP_DISH: '/api/admin/dashboard/top-dish',
    GET_FINANCIAL_SNAPSHOT: '/api/admin/dashboard/financial-snapshot',
  },

  //   DASHBOARD: {
  //   GET_SUMMARY: '/api/admin/dashboard/summary',
  //   GET_TOP_SELLING: '/api/admin/dashboard/top-selling',
  //   GET_BANK_COLLECTIONS: '/api/admin/dashboard/bank-collections', // optional if exists
  // },

  TABLES: {
    GET_ALL: '/api/admin/tables',
    GET_BY_ID: (id) => `/api/admin/tables/${id}`,
    CREATE: '/api/admin/tables',
    UPDATE: (id) => `/api/admin/tables/${id}`,
    GET_BY_SECTION: (section) => `/api/admin/tables/section/${section}`,
    UPDATE_STATUS: (id) => `/api/admin/tables/${id}/status`,
    DELETE: (id) => `/api/admin/tables/${id}`,
    ACTIVATE: (id) => `/api/admin/tables/activate/${id}`,
    MERGE: '/api/admin/tables/merge',
    TRANSFER: '/api/admin/tables/transfer',
    DEACTIVATE: (id) => `/api/admin/tables/deactivate/${id}`,
  },

  TABLE_SPLITS: {
    BASE: '/api/table-splits',
    GET_ALL: '/api/table-splits',
    GET_BY_TABLE: (tableId) => `/api/table-splits/table/${tableId}`,
    CREATE: '/api/table-splits',
    UPDATE_SPLIT: (tableId, splitName) => `/api/table-splits/update?tableId=${tableId}&splitName=${splitName}`,
    UPDATE_STATUS: (id) => `/api/table-splits/${id}/status`,
    UPDATE_PEOPLE_COUNT: (id) => `/api/table-splits/${id}/people-count`,
    DELETE: (id) => `/api/table-splits/${id}`,
    CLEAR_TABLE: (tableId) => `/api/table-splits/clear/${tableId}`,
    CLEANUP_COUNTER: (tableId) => `/api/table-splits/cleanup-counter/${tableId}`,
    MERGE: '/api/table-splits/merge',
    UNMERGE: (tableId, splitName) => `/api/table-splits/unmerge?tableId=${tableId}&splitName=${splitName}`,
    ADD_TO_MERGE: '/api/table-splits/merge/add',
  },

  SECTIONS: {
    GET_ALL: '/api/admin/section',
    CREATE: '/api/admin/section',
    UPDATE: (id) => `/api/admin/section/${id}`,
    DELETE: (id) => `/api/admin/section/${id}`,
    ACTIVATE: (id) => `/api/admin/section/activate/${id}`,
    DEACTIVATE: (id) => `/api/admin/section/deactivate/${id}`,
  },


  KITCHEN_STATIONS: {
    BASE: "/api/admin/kitchen-stations",
    CREATE: "/api/admin/kitchen-stations",
    UPDATE: (id) => `/api/admin/kitchen-stations/${id}`,
    DELETE: (id) => `/api/admin/kitchen-stations/${id}`,
    ACTIVATE: (id) => `/api/admin/kitchen-stations/activate/${id}`,
    DEACTIVATE: (id) => `/api/admin/kitchen-stations/deactivate/${id}`,
  },
  TABLE_LAYOUT: {
    GET_BY_NAME: (tableName) => `/api/layout/table/${tableName}`,
    // UPDATE: (tableName) => `/api/layout/table/${tableName}`,
  },
  FETCH_DATA: {
    GET_ALL: (endpoint) => `/api/${endpoint}`,
  },

  // Printer Configuration
  PRINTERS: {
    BASE: '/api/admin/printers',
    GET_ALL: '/api/admin/printers',
    GET_ALL_FOR_ADMIN: '/api/admin/printers/all',
    GET_BY_ID: (id) => `/api/admin/printers/${id}`,
    CREATE: '/api/admin/printers',
    UPDATE: (id) => `/api/admin/printers/${id}`,
    DELETE: (id) => `/api/admin/printers/${id}`,
    GET_BY_TYPE: (type) => `/api/admin/printers/type/${type}`,
    GET_DEFAULT: (type) => `/api/admin/printers/default/${type}`,
    GET_BY_STATION: (stationId) => `/api/admin/printers/station/${stationId}`,
    ACTIVATE: (id) => `/api/admin/printers/activate/${id}`,
    DEACTIVATE: (id) => `/api/admin/printers/deactivate/${id}`,
    SET_DEFAULT: (id) => `/api/admin/printers/set-default/${id}`,
    SYSTEM_PRINTERS: '/api/admin/printers/system-printers',
  },

  // Print Operations
  PRINT: {
    BILL: '/api/print/bill',
    KOT: '/api/print/kot',
    CANCEL_KOT: '/api/print/kot/cancel',
    KOT_TO_STATION: (stationName) => `/api/print/kot/station/${stationName}`,
    TEST: '/api/print/test',
    TEST_TEMPLATE: '/api/print/test-template',
  },

  // Receipt Configuration
  RECEIPT_CONFIGURATIONS: {
    BASE: '/api/admin/receipt-configurations',
    GET_ALL: '/api/admin/receipt-configurations',
    GET_ACTIVE: '/api/admin/receipt-configurations/active',
    GET_BY_ID: (id) => `/api/admin/receipt-configurations/${id}`,
    CREATE: '/api/admin/receipt-configurations',
    UPDATE: (id) => `/api/admin/receipt-configurations/${id}`,
    DELETE: (id) => `/api/admin/receipt-configurations/${id}`,
    GET_BY_TYPE: (type) => `/api/admin/receipt-configurations/type/${type}`,
    GET_ACTIVE_BY_TYPE: (type) => `/api/admin/receipt-configurations/type/${type}/active`,
    GET_DEFAULT: (type) => `/api/admin/receipt-configurations/default/${type}`,
    ACTIVATE: (id) => `/api/admin/receipt-configurations/activate/${id}`,
    DEACTIVATE: (id) => `/api/admin/receipt-configurations/deactivate/${id}`,
    SET_DEFAULT: (id) => `/api/admin/receipt-configurations/set-default/${id}`,
    DUPLICATE: (id) => `/api/admin/receipt-configurations/${id}/duplicate`,
  },

  // Organization (Master Data)
  ORGANIZATION: {
    GET_CURRENT: '/organization/current',
    GET_ALL: '/organization',
    GET_BY_ID: (id) => `/organization/${id}`,
    CREATE: '/organization',
    UPDATE: (id) => `/organization/${id}`,
    DELETE: (id) => `/organization/${id}`,
  },

  // Branch (Restaurant Details)
  BRANCH: {
    GET_CURRENT: '/branch/current',
    GET_ALL: '/branch',
    GET_BY_ID: (id) => `/branch/${id}`,
    CREATE: '/branch',
    UPDATE: (id) => `/branch/${id}`,
    DELETE: (id) => `/branch/${id}`,
  },

  // File Uploads
  UPLOADS: {
    LOGO: '/api/uploads/logo',
    GET_LOGO: (branchId, filename) => `/api/uploads/logos/${branchId}/${filename}`,
    DELETE_LOGO: '/api/uploads/logo',
    CONFIG: '/api/uploads/config',
    MENU_ITEM_IMAGE: (menuItemId) => `/api/uploads/menu-items/${menuItemId}`,
    GET_MENU_ITEM_IMAGE: (filename) => `/api/uploads/menu-items/${filename}`,
  },
  CUSTOMER: {
    BASE: '/api/admin/customer',
    GET_ALL: '/api/admin/customer',
    GET_BY_ID: (id) => `/api/admin/customer/${id}`,
    CREATE: '/api/admin/customer',
    UPDATE: (id) => `/api/admin/customer/${id}`,
    DELETE: (id) => `/api/admin/customer/${id}`,
    GET_PROFILE: (id) => `/api/admin/customer/${id}/orders/summary`,
    GET_LOYALTY_TRANSACTIONS: (id) =>
      `/api/admin/customer/${id}/loyalty-transactions`,
    GET_LOYALTY_BALANCE: (id) => `/api/admin/customer/${id}/loyalty-balance`,
    REDEEM_POINTS: (id) => `/api/admin/customer/${id}/redeem-points`,
    GET_CAMPAIGN_REPORT: '/api/admin/customer/campaign-customer-report',
    GET_SEGMENT_COUNTS: '/api/admin/customer/segment/counts',
    SEND: '/api/admin/customer/campaigns/send',
    SUBMIT_FEEDBACK: (branchId) => `/api/feedback/${branchId}`,
    GET_FEEDBACK_LIST: '/api/admin/customer/feedback',

  },
  TAX: {
    BASE: '/api/admin/tax',
    GET_ALL: '/api/admin/tax',
    GET_BY_ID: (id) => `/api/admin/tax/${id}`,
    CREATE: '/api/admin/tax',
    UPDATE: (id) => `/api/admin/tax/${id}`,
    DELETE: (id) => `/api/admin/tax/${id}`,
  },

  NOTIFICATION: {
    BASE: "/api/admin/notification/settings",
    GET_ALL: "/api/admin/notification/settings",
    UPDATE: (id) => `/api/admin/notification/settings/${id}`,
  },
  INTEGRATION: {
    WHATSAPP_PROVIDER: {
      BASE: "/api/admin/notificationProvider",
      GET_ALL: "/api/admin/notificationProvider",
      CREATE: "/api/admin/notificationProvider",
      UPDATE: (id) => `/api/admin/notificationProvider/${id}`,
      DELETE: (id) => `/api/admin/notificationProvider/${id}`,
      ACTIVATE: (id) => `/api/admin/notificationProvider/${id}/activate`,
      DEACTIVATE: (id) => `/api/admin/notificationProvider/${id}/deactivate`,
    },
  },
  UOM: {
    GET_ALL: "/api/inventory/uom",
    CREATE: "/api/inventory/uom",
    UPDATE: (id) => `/api/inventory/uom/${id}`,
    DELETE: (id) => `/api/inventory/uom/${id}`,
    GET_CATEGORIES: "/api/inventory/uom/categories",
  },
  UOM_CATEGORY: {
    GET_ALL: "/api/inventory/uom-category",
    GET_ACTIVE: "/api/inventory/uom-category/active",
    GET_BY_ID: (id) => `/api/inventory/uom-category/${id}`,
    CREATE: "/api/inventory/uom-category",
    UPDATE: (id) => `/api/inventory/uom-category/${id}`,
    DELETE: (id) => `/api/inventory/uom-category/${id}`,
  },

  INVENTORY_ITEMS: {
    GET_ALL: "/api/inventory/items",
    GET_BY_ID: (id) => `/api/inventory/items/${id}`,
    CREATE: "/api/inventory/items",
    UPDATE: (id) => `/api/inventory/items/${id}`,
    DELETE: (id) => `/api/inventory/items/${id}`,
    SUMMARY: "/api/inventory/items/summary",
    LOW_STOCK: "/api/inventory/items/low-stock",
    OUT_OF_STOCK: "/api/inventory/items/out-of-stock",
    DOWNLOAD_TEMPLATE: "/api/inventory/items/bulk/template",
    BULK_UPLOAD: "/api/inventory/items/bulk/upload",
    BULK_UPLOADS: "/api/inventory/items/bulk/uploads",
    ITEM_HISTORY: "/api/inventory/item-history",
    BULK_DOWNLOAD: (id) => `/api/inventory/items/bulk/download/${id}`,
  },

  INVENTORY_STATS: {
    TOTAL_VALUE: "/api/inventory/stats/total-value",
    TOTAL_ITEMS: "/api/inventory/stats/total-items",
    OUT_OF_STOCK_COUNT: "/api/inventory/stats/out-of-stock-count",
    LOW_STOCK_COUNT: "/api/inventory/stats/low-stock-count",

  },
  INVENTORY_CATEGORY: {
    GET_ALL: "/api/inventory/category",
    CREATE: "/api/inventory/category",
    UPDATE: (id) => `/api/inventory/category/${id}`,
    DELETE: (id) => `/api/inventory/category/${id}`,
    ACTIVATE: (id) => `/api/inventory/category/activate/${id}`,
    DEACTIVATE: (id) => `/api/inventory/category/deactivate/${id}`,
  },
  TABLE_RESERVATIONS: {
    BASE: '/api/admin/table-reservations',
    GET_ALL: '/api/admin/table-reservations',
    GET_BY_ID: (id) => `/api/admin/table-reservations/${id}`,
    CREATE: '/api/admin/table-reservations',
    UPDATE: (id) => `/api/admin/table-reservations/${id}`,
    DELETE: (id) => `/api/admin/table-reservations/${id}`,
    UPDATE_STATUS: (id, status) => `/api/admin/table-reservations/${id}/status?status=${status}`,
    CANCEL: (id) => `/api/admin/table-reservations/${id}/cancel`,
    MARK_SEATED: (id) => `/api/admin/table-reservations/${id}/seated`,
    MARK_COMPLETED: (id) => `/api/admin/table-reservations/${id}/completed`,
    MARK_NO_SHOW: (id) => `/api/admin/table-reservations/${id}/no-show`,
    BY_DATE: (date) => `/api/admin/table-reservations/by-date?date=${date}`,
    BY_DATE_JSON: (date) => `/api/admin/table-reservations/by-date/json?date=${date}`,
    BY_TABLE: (tableId, date) => `/api/admin/table-reservations/by-table?tableId=${tableId}&date=${date}`,
    UPCOMING: '/api/admin/table-reservations/upcoming',
    UPCOMING_JSON: '/api/admin/table-reservations/upcoming/json',
    TODAY: '/api/admin/table-reservations/today',
    TODAY_JSON: '/api/admin/table-reservations/today/json',
    IS_BLOCKED: (tableId) => `/api/admin/table-reservations/table/${tableId}/is-blocked`,
    GET_BLOCKING: (tableId) => `/api/admin/table-reservations/table/${tableId}/blocking`,
  },
  RECIPE: {
    BASE: '/api/admin/recipe',
    CREATE: '/api/admin/recipe',
    GET_ALL: '/api/admin/recipe',
    GET_BY_ID: (id) => `/api/admin/recipe/${id}`,
    DELETE: (id) => `/api/admin/recipe/${id}`,
    GET_BY_MENU_ITEM: (menuItemId) =>
      `/api/admin/recipe/menu-item/${menuItemId}`,
    UPDATE_INGREDIENTS: (recipeId) =>
      `/api/admin/recipe/${recipeId}/ingredients`,
    DELETE_INGREDIENT: (recipeId, ingredientId) =>
      `/api/admin/recipe/${recipeId}/ingredients/${ingredientId}`,
    UPDATE: (id) => `/api/admin/recipe/${id}`,

  },

  STOCK: {
    PURCHASE: "/api/inventory/stock/purchase",
    DEDUCT: "/api/inventory/stock/deduct",
    UPDATES: "/api/inventory/stock/updates",
    CONSUME: (billId) => `/api/inventory/stock/consume/${billId}`,
    CONSUMPTION_OVERVIEW: "/api/inventory/stock/stock-consumption-overview",
  },

  PURCHASE_ORDERS: {
    GET_ALL: '/api/inventory/purchase-orders',
    GET_BY_ID: (id) => `/api/inventory/purchase-orders/${id}`,
    CREATE: '/api/inventory/purchase-orders',
    UPDATE: (id) => `/api/inventory/purchase-orders/${id}`,
    DELETE: (id) => `/api/inventory/purchase-orders/${id}`,
    UPDATE_STATUS: (id) => `/api/inventory/purchase-orders/${id}/status`,
    RECEIVE: (id) => `/api/inventory/purchase-orders/${id}/receive`,
    UPLOAD_EXCEL: '/api/inventory/purchase-orders/upload/excel',
    UPLOAD_IMAGE: '/api/inventory/purchase-orders/upload/image',
    EXTRACT: '/api/inventory/purchase-orders/extract',
    STATS: '/api/inventory/purchase-orders/stats',
    SUPPLIERS: '/api/inventory/suppliers',
  },
  WASTE_TRACKING: {
    CREATE: '/api/inventory/waste/log',           // ✅ POST new waste
    LOG_ENTRIES: '/api/inventory/waste/entries',          // ✅ GET all waste entries
    TODAY: '/api/inventory/waste/today',          // ✅ GET today's waste
    STATS: '/api/inventory/waste/stats',          // ✅ GET statistics
    ANALYTICS: '/api/inventory/waste/analytics',  // ✅ GET analytics
    INVENTORY_ITEMS: '/api/inventory/items',      // ✅ GET inventory
  },
    SUPPLIERS: {
    // Core CRUD
    GET_ALL:       '/api/inventory/suppliers',
    GET_BY_ID:     (id) => `/api/inventory/suppliers/${id}`,
    CREATE:        '/api/inventory/suppliers',
    UPDATE:        (id) => `/api/inventory/suppliers/${id}`,
    DELETE:        (id) => `/api/inventory/suppliers/${id}`,
    TOGGLE_STATUS: (id) => `/api/inventory/suppliers/${id}/toggle-status`,
    GET_STATS:     '/api/inventory/suppliers/stats',
 
    // Sub-resources
    GET_ORDERS:      (id) => `/api/inventory/suppliers/${id}/orders`,
    GET_PRICE_LIST:  (id) => `/api/inventory/suppliers/${id}/price-list`,
    GET_PERFORMANCE: (id) => `/api/inventory/suppliers/${id}/performance`,
    GET_DOCUMENTS:   (id) => `/api/inventory/suppliers/${id}/documents`,
    GET_ACTIVITY:    (id) => `/api/inventory/suppliers/${id}/activity`,
  },

  // Users (Waiters, Staff)
  USERS: {
    BASE: '/user',
    GET_ALL: '/user',
    GET_BY_ID: (id) => `/user/${id}`,
    FILTER: '/user/filter',
    CREATE: '/user',
    UPDATE: (id) => `/user/${id}`,
    DELETE: (id) => `/user/${id}`,
    UPDATE_PREFERENCE: (id) => `/user/${id}/preference`,
    BY_ROLE: (role) => `/user/by-role/${role}`,

  },
  ROLES: {
    GET_ALL: "/role",
    GET_BY_ID: (id) => `/role/${id}`,
    CREATE: "/role",
    UPDATE: (id) => `/role/${id}`,
    DELETE: (id) => `/role/${id}`,
  },
  PERMISSIONS: {
  GET_ALL: "/api/permissions",
},
  // Reports
  REPORTS: {
    DAILY_SALES: '/api/reports/daily-sales',
    ITEM_WISE_SALES: '/api/reports/item-wise-sales',
    // CATEGORY_SALES: '/api/reports/category-sales',
    CATEGORY_WISE_SALES: '/api/reports/category-wise-sales',
    HOURLY_SALES: '/api/reports/hourly-sales',
    PAYMENT_ANALYSIS: '/api/reports/payment-analysis',
    GST_REPORT: '/api/reports/gst',
    GST_DOWNLOAD: '/api/reports/gst/download',
    WAITER_PERFORMANCE: '/api/reports/waiter-performance',
    TABLE_UTILIZATION: '/api/reports/table-utilization',
    CUSTOMER_INSIGHTS: '/api/reports/customer-insights',
    CUSTOMER_RETENTION_DAILY: '/api/reports/customer-retention-daily',
    DISCOUNT_ANALYSIS: '/api/reports/discount-analysis',
    DISCOUNT_CODES: '/api/reports/discount-codes',
    REVENUE_SUMMARY: '/api/reports/revenue-summary',
    WAITER_PERFORMANCE: '/api/reports/waiter-performance',
    KOT_TIMING_ANALYSIS: '/api/reports/kot-timing-analysis',
    STOCK_STATUS: '/api/reports/stock-status',
    LOYALTY_POINTS: '/api/reports/loyalty-point',
    CONSUMPTION_WISE_SALES: '/api/reports/consumption-wise-sales',
  },

  DISCOUNT: {
    BASE: "/api/admin/discount",
    CREATE: "/api/admin/discount",
    GET_ALL: "/api/admin/discount",
    UPDATE: (id) => `/api/admin/discount/${id}`,
    DELETE: (id) => `/api/admin/discount/${id}`,
    DEACTIVATE: (id) => `/api/admin/discount/deactivate/${id}`,
    GET_BY_ID: (id) => `/api/admin/discount/${id}`,
    GET_BY_CODE: (code) => `/api/admin/discount/code/${encodeURIComponent(code)}`,
  },
  LOYALTY_PROGRAM: {
    BASE: "/api/admin/loyalty-program",
    GET_ALL: "/api/admin/loyalty-program",
    UPDATE: `/api/admin/loyalty-program`,

  },
  DISCOUNT_POS: {
    SUGGESTIONS: "/api/pos/discount/suggestions",
    VALIDATE: "/api/pos/discount/validate",
    GET_BY_CODE: (code) => `/api/pos/discount/code/${encodeURIComponent(code)}`,
    CUSTOMER_USAGE: (discountId, customerId) => `/api/pos/discount/${discountId}/customer/${customerId}/usage`,
  },

  // KDS (Kitchen Display System) - Optimized APIs
  KDS: {
    GET_ORDERS: '/api/kds/orders',
    GET_STATS: '/api/kds/orders/stats',
    UPDATE_STATUS: (orderId) => `/api/kds/orders/${orderId}/status`,
    UPDATE_ITEM_STATUS: (orderId, itemId) => `/api/kds/orders/${orderId}/items/${itemId}/status`,
    GET_ITEM_STATS: (orderId) => `/api/kds/orders/${orderId}/item-stats`,
  },

  //  REPORTS: {
  //       PAYMENT_ANALYSIS: '/api/reports/payment-analysis',
  //        CUSTOMER_INSIGHTS: '/api/reports/customer-insights',
  //  },

  // QR Config
  QR_CONFIG: {
    GET: '/api/admin/qr-config',
    CREATE: '/api/admin/qr-config',
    UPDATE: '/api/admin/qr-config',
    DELETE: '/api/admin/qr-config',
    TOGGLE_ORDERING: '/api/admin/qr-config/toggle-ordering',
  },

  // QR Codes
  QR_CODES: {
    GET_ALL: '/api/admin/qr-codes',
    GET_BY_ID: (id) => `/api/admin/qr-codes/${id}`,
    GET_BY_TABLE: (tableId) => `/api/admin/qr-codes/table/${tableId}`,
    CREATE: '/api/admin/qr-codes',
    BULK_CREATE: '/api/admin/qr-codes/bulk',
    TOGGLE: (id) => `/api/admin/qr-codes/${id}/toggle`,
    DELETE: (id) => `/api/admin/qr-codes/${id}`,
    DELETE_ALL: '/api/admin/qr-codes',
  },

  // QR Orders (Admin/POS)
  QR_ORDERS: {
    GET_PENDING: '/api/admin/qr-orders/pending',
    GET_ALL: '/api/admin/qr-orders',
    APPROVE: (id) => `/api/admin/qr-orders/${id}/approve`,
    REJECT: (id) => `/api/admin/qr-orders/${id}/reject`,
  },

  // QR Public (Customer-facing, no auth) - branchId in path for tenant routing
  QR_PUBLIC: {
    CREATE_SESSION: (branchId) => `/public/qr/${branchId}/session`,
    PLACE_ORDER: (branchId) => `/public/qr/${branchId}/orders`,
    GET_ORDERS: (branchId) => `/public/qr/${branchId}/orders`,
    UPDATE_CUSTOMER_INFO: (branchId) => `/public/qr/${branchId}/session/customer-info`,
  },

  // Tenant Management & Onboarding
  TENANT: {
    SETUP: {
      CREATE_ORG: '/api/platform/setup/organizations',
      GET_ALL_ORGS: '/api/platform/setup/organizations',
      REGISTER_DB: '/api/platform/setup/databases',
      UPDATE_DB: (dbConfigId) => `/api/platform/setup/databases/${dbConfigId}`,
      SYNC_ORG: (orgId, branchId) => `/api/platform/setup/org/${orgId}/branch/${branchId}`,
      CREATE_BRANCH: '/api/platform/setup/branch',
      SYNC_BRANCHES: (orgId) => `/api/platform/setup/organizations/${orgId}/sync-branches`,
      COMPLETE_SETUP: '/api/platform/setup/complete-setup',
      CREATE_ADMIN_USER: (orgId) => `/api/platform/setup/organizations/${orgId}/admin-user`,
      RELOAD_DATASOURCES: '/api/platform/setup/databases/reload',
      VALIDATE_TOKEN: '/api/platform/setup/validate-token',
      STATUS: '/api/platform/setup/branches/status',
      GET_TENANT_DETAILS: (branchId) => `/api/platform/setup/tenant-details/${branchId}`,
      UPDATE_ORG: (orgId) => `/api/platform/setup/organizations/${orgId}`,
      UPDATE_BRANCH: (branchId) => `/api/platform/setup/branch/${branchId}`,
    },
    MIGRATIONS: {
      RUN_ALL: '/api/platform/migrations/run-all',
      RUN_FOR_ORG: (orgId, branchId) => `/api/platform/migrations/org/${orgId}/branch/${branchId}`,
      STATUS: '/api/platform/migrations/status',
    },
    SUPER_ADMIN: {
      USERS: {
        GET_ALL: '/api/platform/setup/users',
        UPDATE_STATUS: (id) => `/api/platform/setup/users/${id}/status`,
      }
    }
  },
  MODULES: {
    ENABLED: '/modules/enabled',
  },

  MODULE_SUBSCRIPTION: {
  GET_BRANCH_MODULES: (branchId) => `/api/platform/setup/branch/${branchId}`,
  UPDATE_BRANCH_MODULES: (branchId) => `/api/platform/setup/branch/${branchId}`,
  DELETE_BRANCH_MODULE: (branchId, moduleCode) => `/api/platform/setup/branch/${branchId}/${moduleCode}`,
  GET_CURRENT_USER_MODULES: '/api/platform/setup/current-user-modules',
},
STOCK_ADJUSTMENTS: {
  STATS: '/api/inventory/adjustment-stats',
  ITEMS: '/api/inventory/items',
  ADJUST: '/api/inventory/stock/adjust',
  HISTORY: '/api/inventory/adjustments-history',
},

}

export default ENDPOINTS;

// Set the API base URL for the backend
export const API_BASE_URL = 'http://localhost:8081';